import rawData from './introData.json';
import introCoin from './assets/intro-coin.webp';
import introStrip from './assets/intro-strip.webp';
import introArch from './assets/intro-arch.webp';

/* The Lottie JSON was exported with placeholder image paths; point them at
   the bundled assets by asset id. */
const ASSET_URLS = { 0: introCoin, 1: introStrip, 2: introArch };

const introAnimation = JSON.parse(JSON.stringify(rawData));
introAnimation.assets.forEach((a) => {
  if (a.p && ASSET_URLS[a.id]) {
    a.p = ASSET_URLS[a.id];
    a.u = '';
    a.e = 0; // path, not embedded data
  }
});

export default introAnimation;
